
import React, { useEffect, useState } from 'react'
import Header from "../../../../Components/Header/Header"
import Sidebar from "../../../../Components/Sidebar/Sidebar"
import Select from 'react-select'
import { useAuthState } from "../../../../Helper/Context";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { AssetTypeDataDDL } from '../../../../Components/CommonDDL/AssetTypeDataDDL';
import { WardNameDataDDL } from '../../../../Components/CommonDDL/WardNameDataDDL';
import { MonthDataDDL } from '../../../../Components/CommonDDL/MonthDataDDL';
import { FinancialYearDataDDL } from '../../../../Components/CommonDDL/FinancialYearDataDDL';
import { ReopenWorkProgressTableDataAPI } from '../../../../Redux/GardenDashboardSlice/ReopenWorkProgressSlice';
import moment from "moment";
import ViewURL from '../../../../Components/ViewURL/ViewURL';
import { Loading } from '../../../../Helper/Loading';
import { Pegination } from '../../../../Components/Pegination/Pegination';
import { WorkAssignByDDL } from '../../../../Components/CommonDDL/WorkAssignByDDL';
import { GardenReopenPendingExport } from './GardenReopenPendingExport';


export default function GardenReopenPending() {

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    const [searchParams] = useSearchParams()
    let searchName = searchParams.get("name")
    let ApiFlag = searchParams.get("ApiFlag")
    let FlagName = searchParams.get("Flag")
    let HYear = searchParams.get("Year")
    let YLable = searchParams.get("YLable")
    let HMonth = searchParams.get("Month")
    let MLable = searchParams.get("MLable")
    let HWard = searchParams.get("WardName")
    let WLable = searchParams.get("WLable")
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")

    // console.log(FlagName)

    const [FinancialYear, setFinancialYear] = useState({
        DDL: [],
        ID: HYear && HYear ? HYear : '0',
        Label: YLable && YLable ? YLable : "Select...",
    })
    const [Month, setMonth] = useState({
        DDL: [],
        ID: HMonth && HMonth ? HMonth : '0',
        Label: MLable && MLable ? MLable : "Select...",

    })
    const [WardName, setWardName] = useState({
        DDL: [],
        ID: HWard && HWard ? HWard : '0',
        Label: WLable && WLable ? WLable : "Select...",
    })
    const [AssetType, setAssetType] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [WorkAssignedBy, setWorkAssignedBy] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    // ----------pagination-------------
    const [PerPageCount, setPerPageCount] = useState(10)
    const [TotalCount, setTotalCount] = useState(0)
    const [To, setTo] = useState(10)
    const [From, setFrom] = useState(1)
    const [rowNo, setrowNo] = useState(1)
    const [CurrentPage, setCurrentPage] = useState(0)

    const [isSearch, setIsSearch] = useState(false)
    const [IsClear, setIsClear] = useState(false)
    const [IsPost, setIsPost] = useState(false)
    const [YearValue, setYearValue] = useState(0)
    const [ImagePopUpData, setImagePopUpData] = React.useState('')
    const [showImagePopup, setshowImagePopup] = React.useState(false)
    const [ImageHeading, setImageHeading] = useState('')
    // const [FromDate, setFromDate] = useState(moment(HMonth, 'MM').year(HYear, 'YYYY').startOf('month').format('YYYY-MM-DD'))
    const [FromDate, setFromDate] = useState(moment().startOf('month').format('YYYY-MM-DD'))
    const [ToDate, setToDate] = useState(moment().format('YYYY-MM-DD'))

    const [PopUpField, setPopUpField] = React.useState({
        addPopUp: false,
        deletePopUp: false,
        popupFlag: '',
        popupBtn: "",
        apiFlag: "",
        rowData: ''
    })

    const handleClear = () => {
        setTo(10)
        setFrom(1)
        setCurrentPage(0)
        setIsClear(!IsClear)
        setFromDate(moment().startOf('month').format('YYYY-MM-DD'))
        setToDate(moment().format('YYYY-MM-DD'))
        setWardName({
            ...WardName,
            ID: HWard,
            Label: WLable,
        })
        setAssetType({
            ...AssetType,
            ID: 0,
            Label: 'Select...',
        })
        setWorkAssignedBy({
            ...WorkAssignedBy,
            ID: 0,
            Label: 'Select...',
        })
        // console.log("call")
    }

    // useEffect(() => {
    //     if (FromDate != moment().startOf('month').format('YYYY-MM-DD')) {
    //         setToDate(moment(HMonth, 'MM').year(HYear, 'YYYY').endOf('month').format('YYYY-MM-DD'))
    //     }
    // }, [FromDate])

    const handlePost = () => {
        setIsPost(!IsPost)
    }

    const handleShowImage = (img) => {
        setshowImagePopup(true)
        setImagePopUpData(img)
    }


    useEffect(() => {
        const data = {
            FromDate: FromDate,
            ToDate: ToDate,
            M_WardID: WardName.ID,
            WorkAssignedByID: WorkAssignedBy.ID,
            M_AssetTypeID: AssetType.ID,
            M_UsersID: UserID,
            token: token,
            From: From,
            To: To,
            Flag: ApiFlag,
        }
        if (WardName.ID) {
            dispatch(ReopenWorkProgressTableDataAPI({ data }))
        }
    }, [IsPost, To, IsClear, isSearch])

    useEffect(() => {
        const data = {
            FromDate: FromDate,
            ToDate: ToDate,
            M_WardID: WardName.ID,
            WorkAssignedByID: WorkAssignedBy.ID,
            M_AssetTypeID: AssetType.ID,
            M_UsersID: UserID,
            token: token,
            From: '1',
            To: '99999',
            Flag: ApiFlag,
        }
        if (WardName.ID) {
            dispatch(ReopenWorkProgressTableDataAPI({ data }))
        }

    }, [IsPost, IsClear, isSearch])

    const { tableData, isLoading } = useSelector(state => state.ReopenWorkProgressTableData)
    const { ReopenPendingCompletedTableData, isExportLoading } = useSelector(state => state.ReopenWorkProgressExportTableData)

    const handleSearch = () => {
        setCurrentPage(0)
        setTo(10)
        setFrom(1)
        setIsSearch(!isSearch)
    }

    // useEffect(() => {
    //     setCurrentPage(0)
    //     setFrom(1)
    //     setTo(10)
    // }, [WardName.ID, FinancialYear.ID, Month.ID, AssetType.ID])

    return (
        <>
            {isLoading && <Loading />}
            <div>
                <Header
                    DashboardHeading="Garden Maintainance"
                    MLable={MLable}
                    HMonth={HMonth}
                    YLable={YLable}
                    HYear={HYear}
                    HWard={HWard}
                    WLable={WLable}
                    flag='Screen'
                    DashboardName={DashboardName}
                />
                <div className="wrapper">
                    <Sidebar ProjectTypeId={ProjectTypeId} />
                    <div id="" className='content1 content'>
                        <div className='data_mob'>
                            <div className="row m-1 py-1 pb-4 master_border">
                                <div className='col-8'>
                                    <h5 className="ps-1 pt-1 ">Reopen Work Progress {searchName}</h5>
                                </div>
                                <div className='col-4'>
                                    {
                                        isExportLoading ?
                                            <button type="button" className="btn btn-primary float-end mr-1 mb-1 ml-1" disabled>
                                                <i
                                                    className="fa fa-refresh fa-spin"
                                                    style={{ marginRight: "5px" }}
                                                />Loading</button>
                                            :
                                            // ReopenPendingCompletedTableData && ReopenPendingCompletedTableData.table && ReopenPendingCompletedTableData.table.length 
                                            tableData && tableData.table && tableData.table.length > 0 &&
                                            <GardenReopenPendingExport
                                                ExcelData={ReopenPendingCompletedTableData}
                                                name={searchName}
                                                searchName={searchName}
                                            />
                                    }

                                </div>
                                <div className="row m-0 mt-1">
                                    <div className="col-12 py-1 rounded rounded-2 shadow"
                                        style={{ border: "1px solid #00000024", background: "#27466317" }}>
                                        <div className="col-12  ">

                                            <div className="row py-1 rounded2">
                                                <div className="col-12 col-md-6 col-lg-2">
                                                    <div className="form-group">
                                                        <label className="d-block" htmlFor="NameofDepartment"> <b>From Date :</b></label>
                                                        <input type="date"
                                                            className="form-control"
                                                            id="FromDate"
                                                            value={FromDate}
                                                            onChange={(e) => (setFromDate(e.target.value), setToDate(''))} />
                                                    </div>
                                                </div>
                                                <div className="col-12 col-md-6 col-lg-2">
                                                    <div className="form-group">
                                                        <label className="d-block" htmlFor="NameofDepartment"><b>To Date :</b></label>
                                                        <input type="date"
                                                            className="form-control"
                                                            id="ToDate"
                                                            value={ToDate}
                                                            onChange={(e) => setToDate(e.target.value)} />

                                                    </div>
                                                </div>
                                                <div className="col-12 col-md-6 col-lg-2">
                                                    <WardNameDataDDL
                                                        WardName={WardName}
                                                        setWardName={setWardName}
                                                        HWard={HWard}
                                                        WLable={WLable}
                                                    />
                                                </div>
                                                <div className="col-12 col-md-6 col-lg-3 " >
                                                    <WorkAssignByDDL
                                                        WorkAssignedBy={WorkAssignedBy}
                                                        setWorkAssignedBy={setWorkAssignedBy}
                                                        Flag={FlagName}
                                                    />

                                                </div>
                                                <div className="col-12 col-md-6 col-lg-3 ">
                                                    <AssetTypeDataDDL
                                                        AssetType={AssetType}
                                                        setAssetType={setAssetType}
                                                    />
                                                </div>
                                                <div className="btn-action col-12 col-md-4 col-lg-2 mt-md-4 d-md-flex" >
                                                    <div className='d-md-flex' style={{ marginTop: "-1em" }}>
                                                        <button type="button"
                                                            className="btn-clear btn btn-primary mx-2"
                                                            onClick={handleSearch}
                                                        >
                                                            Search</button>
                                                        <button type="button"
                                                            className="btn btn-outline-danger"
                                                            onClick={handleClear}
                                                        >
                                                            Clear</button>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row mob_table table-responsive pt-1">
                                                <table
                                                    id="totalordergenerated"
                                                    cellPadding="0"
                                                    cellSpacing="0"
                                                    border="0"
                                                    className="table table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th className="sr_no_col">Sr No.</th>
                                                            {
                                                                searchName == 'Reopen Pending' ?
                                                                    <>
                                                                        {/* <th>Work Done Date</th> */}
                                                                        <th>Reopen Date</th>
                                                                    </>
                                                                    : searchName == 'Reopen Assign' ?
                                                                        <>
                                                                            <th>Work Reopen Date</th>
                                                                            
                                                                        </>
                                                                        :
                                                                        <>
                                                                           <th>Work Reopen Date</th>
                                                                           <th>Reopen Completed Work Date</th>

                                                                        </>

                                                            }

                                                            <th>Asset Name</th>
                                                            <th>Sector Name	 </th>
                                                            <th>Area</th>
                                                            <th>Work Name </th>
                                                            {
                                                                (searchName == 'Reopen Pending') || (searchName == "Reopen Assign") ?
                                                                    <>
                                                                        <th>Completed Work Photo</th>
                                                                        <th>Reopen Work Photo</th>
                                                                    </>
                                                                    :
                                                                    <>
                                                                        {/* <th>Reopen Work Photo</th> */}
                                                                        <th>Reopen Work Photo</th>
                                                                        <th>Reopen Completed Work Photo</th>
                                                                    </>

                                                            }

                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            tableData && tableData.table && tableData.table.length > 0 ? tableData.table.map((item) =>
                                                                <tr>
                                                                    <td className='sr-no-col' style={{ textAlign: "center" }}>{item.rowNum ? item.rowNum : '-'}</td>
                                                                    {
                                                                        searchName == 'Reopen Pending' ?
                                                                            <>
                                                                                {/* <td>{item.workDate ? moment(item.workDate).format("DD-MM-YYYY") : '-'}</td> */}
                                                                                <td className='date-col'>{item.reopenWorkDate ? moment(item.reopenWorkDate).format("DD-MM-YYYY") : '-'}</td>
                                                                            </>
                                                                            : searchName == 'Reopen Assign' ?
                                                                                <>
                                                                                    <>
                                                                                        <td className='date-col'>{item.reopenWorkDate ? moment(item.reopenWorkDate).format("DD-MM-YYYY") : '-'}</td>       
                                                                                    </>
                                                                                </>
                                                                                :
                                                                                <>
                                                                                   <td className='date-col'>{item.reopenWorkDate ? moment(item.reopenWorkDate).format("DD-MM-YYYY") : '-'}</td>
                                                                                   <td className='date-col'>{item.reopenWorkCompletedDate ? moment(item.reopenWorkCompletedDate).format("DD-MM-YYYY") : '-'}</td>
                                                                                </>
                                                                    }

                                                                    <td>{item.assetName ? item.assetName : '-'}</td>
                                                                    <td className='min-w-75'>{item.sectorName ? item.sectorName : '-'}</td>
                                                                    <td className='min-w-110'>{item.areaName ? item.areaName : '-'}</td>
                                                                    <td className='min-w-75 min-w-200'>{item.workname ? item.workname : '-'}</td>
                                                                    {
                                                                        (searchName == 'Reopen Pending') || (searchName == "Reopen Assign") ?
                                                                            <>
                                                                                <td style={{ textAlign: "center" }}>
                                                                                    {
                                                                                        (item.afterAssignWorkPhoto == null) ?
                                                                                            <span>-</span>
                                                                                            :
                                                                                            <>
                                                                                                <i className="fa-solid fa-eye" title='View'
                                                                                                    style={{ cursor: 'pointer', alignItems: "center" }}
                                                                                                    onClick={() => (
                                                                                                        handleShowImage(item.afterAssignWorkPhoto),
                                                                                                        setImageHeading('After Work Photo')
                                                                                                    )}
                                                                                                ></i>
                                                                                            </>
                                                                                    }
                                                                                </td>
                                                                                <td style={{ textAlign: "center" }}>
                                                                                    {
                                                                                        (item.reopenWorkPhoto == null) ?
                                                                                            <span>-</span>
                                                                                            :
                                                                                            <>
                                                                                                <i className="fa-solid fa-eye" title='View'
                                                                                                    style={{ cursor: 'pointer', alignItems: "center" }}
                                                                                                    onClick={() => (
                                                                                                        handleShowImage(item.reopenWorkPhoto),
                                                                                                        setImageHeading('Reopen Work Photo')
                                                                                                    )}
                                                                                                ></i>
                                                                                            </>
                                                                                    }

                                                                                </td>
                                                                            </>
                                                                            :
                                                                            <>
                                                                             
                                                                                <td style={{ textAlign: "center" }}>
                                                                                    {
                                                                                        (item.reopenWorkPhoto == null) ?
                                                                                            <span>-</span>
                                                                                            :
                                                                                            <>
                                                                                                <i className="fa-solid fa-eye"
                                                                                                    style={{ cursor: 'pointer', alignItems: "center" }}
                                                                                                    onClick={() => (
                                                                                                        handleShowImage(item.reopenWorkPhoto),
                                                                                                        setImageHeading('Reopen Work Photo')
                                                                                                    )}
                                                                                                ></i>
                                                                                            </>
                                                                                    }
                                                                                </td>
                                                                                <td style={{ textAlign: "center" }}>
                                                                                    {
                                                                                        (item.reopenWorkCompletedPhoto == null) ?
                                                                                            <span>-</span>
                                                                                            :
                                                                                            <>
                                                                                                <i className="fa-solid fa-eye"
                                                                                                    style={{ cursor: 'pointer', alignItems: "center" }}
                                                                                                    onClick={() => (
                                                                                                        handleShowImage(item.reopenWorkCompletedPhoto),
                                                                                                        setImageHeading('Reopen Completed Work Photo')
                                                                                                    )}
                                                                                                ></i>
                                                                                            </>
                                                                                    }

                                                                                </td>
                                                                               
                                                                            </>

                                                                    }

                                                                </tr>
                                                            ) :
                                                                <td colSpan={15}>No data found</td>
                                                        }
                                                    </tbody>

                                                </table>

                                            </div>
                                            {tableData && tableData.table && tableData.table.length > 0 &&
                                                <Pegination
                                                    PerPageCount={PerPageCount}
                                                    TotalCount={tableData.table[0].totalCount}
                                                    setFrom={setFrom}
                                                    setTo={setTo}
                                                    setrowNo={setrowNo}
                                                    CurrentPage={CurrentPage}
                                                    setCurrentPage={setCurrentPage}
                                                />
                                            }
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                {
                    showImagePopup ?
                        <ViewURL
                            Heading={ImageHeading}
                            setshowImagePopup={setshowImagePopup}
                            ImagePopUpData={ImagePopUpData}

                        />
                        : ''


                }
            </div>
        </>
    )
}